import { LECTURE_SURVEY_STEP } from "../../../resources/constants/lectureSurvey";
import { LECTURE_PANEL_SET_LECTURE_LOADING, LECTURE_PANEL_SET_MENU_LOADING, LECTURE_PANEL_SET_MENU, LECTURE_PANEL_SET_LECTURE, LECTURE_PANEL_RESET, LECTURE_PANEL_SET_CURRENT_LECTURE, LECTURE_PANEL_TOGGLE_SECTION, LECTURE_PANEL_SET_LECTURE_AS_COMPLETED, LECTURE_PANEL_SET_LECTURE_AS_UNLOCKED, LECTURE_PANEL_SET_CURRENT_VIDEO_ID, LECTURE_PANEL_ADMIN_SET_EXISTING_SECTION_UPDATE, LECTURE_PANEL_ADMIN_SET_EXISTING_SECTION_TITLE, LECTURE_PANEL_ADMIN_SET_NEW_SECTION_UPDATE, LECTURE_PANEL_ADMIN_SET_NEW_SECTION_TITLE, LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_TITLE_STATUS, LECTURE_PANEL_ADMIN_SET_EDITING_DESCRIPTION_STATUS, LECTURE_PANEL_ADMIN_SET_SECTION_TITLE, LECTURE_PANEL_ADMIN_SECTION_TITLE_CHECK, LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_TITLE, LECTURE_PANEL_ADMIN_LECTURE_TITLE_CHECK, LECTURE_PANEL_ADMIN_SET_LECTURE_TITLE, LECTURE_PANEL_ADMIN_SET_MENU_LECTURE_TITLE, LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_DESCRIPTION, LECTURE_PANEL_ADMIN_LECTURE_DESCRIPTION_CHECK, LECTURE_PANEL_ADMIN_SET_LECTURE_DESCRIPTION, LECTURE_PANEL_ADMIN_NEW_SECTION_TITLE_CHECK, LECTURE_PANEL_ADMIN_SET_NEW_SECTION_TITLE_LOADING, LECTURE_PANEL_ADMIN_ADD_MENU_SECTION, LECTURE_PANEL_SET_MENU_SECTIONS, LECTURE_PANEL_ADMIN_DELETE_MENU_SECTION, LECTURE_PANEL_SET_MENU_LECTURES, LECTURE_PANEL_SET_LECTURE_AS_FREE, LECTURE_PANEL_ADMIN_ADD_MENU_LECTURE, LECTURE_PANEL_ADMIN_DELETE_MENU_LECTURE, LECTURE_PANEL_ADMIN_ADD_EMBED_PAGE, LECTURE_PANEL_ADMIN_DELETE_EMBED_PAGE, LECTURE_PANEL_ADMIN_ADD_DOCUMENTATION, LECTURE_PANEL_ADMIN_DELETE_DOCUMENTATION, LECTURE_PANEL_ADMIN_SET_DOCUMENTATIONS, LECTURE_PANEL_ADMIN_ADD_DOWNLOAD_FILE, LECTURE_PANEL_ADMIN_DELETE_DOWNLOAD_FILE, LECTURE_PANEL_ADMIN_SET_DOWNLOAD_FILES, LECTURE_PANEL_ADMIN_ADD_ADDITIONAL, LECTURE_PANEL_ADMIN_DELETE_ADDITIONAL, LECTURE_PANEL_ADMIN_SET_ADDITIONALS, LECTURE_PANEL_ADMIN_ADD_VIDEO, LECTURE_PANEL_ADMIN_DELETE_VIDEO, LECTURE_PANEL_ADMIN_SET_DOWNLOAD_FILE_TITLE, LECTURE_PANEL_SET_CREATING_LECTURE_LOADING, LECTURE_PANEL_ADMIN_SET_MENU_VISIBLE, LECTURE_PANEL_SURVEY_SET_STEP, LECTURE_PANEL_SURVEY_SET_SURVEY, LECTURE_PANEL_SURVEY_SET_LOADING, LECTURE_PANEL_SURVEY_SET_CURRENT_QUESTION_ID, LECTURE_PANEL_SURVEY_TOGGLE_SELECT_ANSWER, LECTURE_PANEL_SURVEY_SET_QUESTION_DONE, LECTURE_PANEL_SURVEY_SET_RESULTS, LECTURE_PANEL_SURVEY_SET_QUESTION_LOADING, LECTURE_PANEL_SURVEY_DELETE_QUESTION, LECTURE_PANEL_SURVEY_SET_ANSWER_CORRECT, LECTURE_PANEL_SURVEY_DELETE_ANSWER, LECTURE_PANEL_SURVEY_SET_ANSWER_LOADING, LECTURE_PANEL_SURVEY_ADD_ANSWER, LECTURE_PANEL_SURVEY_SET_ANSWERS, LECTURE_PANEL_SURVEY_SET_QUESTIONS, LECTURE_PANEL_SURVEY_SET_CREATING_LOADING, LECTURE_PANEL_SURVEY_ADD_QUESTION, LECTURE_PANEL_SURVEY_SET_QUESTION_REQUIRED, LECTURE_PANEL_SURVEY_SET_ADMIN_RESULTS, LECTURE_PANEL_SURVEY_SET_ADMIN_RESULTS_LOADING, LECTURE_PANEL_SURVEY_SET_ADMIN_RESULT_LOADING, LECTURE_PANEL_SURVEY_DELETE_ADMIN_RESULT } from "../../actions/ActionTypes";

const defaultState = {
    menu: null,
    isMenuLoading: true,

    lecture: null,
    isLectureLoading: true,
    currentVideoId: null,

    currentLectureId: null,
    selectedSectionId: [],

    isMenuVisible: false,

    // SURVEY
    surveyStep: LECTURE_SURVEY_STEP.START,
    survey: null,
    currentQuestionId: null,
    isSurveyLoading: false,
    surveyResults: null,
    isQuestionCreating: false,
    adminSurveyResults: null,
    isAdminSurveyResultsLoading: true,

    // ADMIN
    onInputFocus: false,
    updateExistingSection: null, // { id: X, title: YYY }
    updateNewSection: {
        isEditing: false,
        title: null,
        isValid: false,
        isLoading: true,
    },
    isSectionTitleValid: true,

    isEditingTitle: false,
    editingLectureTitle: '',
    isEditingLectureTitleValid: true,

    isEditingDescription: false,
    editingLectureDescription: '',
    isEditingLectureDescriptionValid: true,
    isCreatingLectureLoading: false,
};

export default function appReducer(state = defaultState, action) {
    switch (action.type) {
        case LECTURE_PANEL_SET_MENU_LOADING: {
            return { ...state, isMenuLoading: action.payload.isLoading };
        }
        case LECTURE_PANEL_SET_LECTURE_LOADING: {
            return { ...state, isLectureLoading: action.payload.isLoading };
        }
        case LECTURE_PANEL_SET_CREATING_LECTURE_LOADING: {
            return { ...state, isCreatingLectureLoading: action.payload.isLoading };
        }
        case LECTURE_PANEL_SURVEY_SET_CREATING_LOADING: {
            return { ...state, isQuestionCreating: action.payload.isLoading };
        }

        case LECTURE_PANEL_ADMIN_SET_MENU_VISIBLE: {
            return { ...state, isMenuVisible: action.payload.isVisible };
        }
        case LECTURE_PANEL_SET_MENU: {
            return { ...state, menu: action.payload.menu };
        }
        case LECTURE_PANEL_SET_MENU_SECTIONS: {
            return { ...state, menu: { ...state.menu, sections: action.payload.sections } };
        }
        case LECTURE_PANEL_SET_LECTURE: {
            const { lecture } = action.payload;
            return { ...state, lecture, currentVideoId: lecture.videos[0] ? lecture.videos[0].id : null };
        }
        case LECTURE_PANEL_SET_MENU_LECTURES: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        if (s.id !== action.payload.id)
                            return s;

                        return { ...s, lectures: action.payload.lectures };
                    })
                }
            };
        }
        case LECTURE_PANEL_ADMIN_SET_MENU_LECTURE_TITLE: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        return {
                            ...s, lectures: s.lectures.map(l => {
                                // eslint-disable-next-line eqeqeq
                                if (l.id != action.payload.id)
                                    return l;

                                return { ...l, title: action.payload.title };
                            })
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_ADMIN_ADD_MENU_SECTION: {
            return {
                ...state, menu: {
                    ...state.menu, sections: [...state.menu.sections, action.payload.section]
                }
            };
        }
        case LECTURE_PANEL_ADMIN_DELETE_MENU_SECTION: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.filter(s => s.id !== action.payload.id)
                }
            };
        }

        case LECTURE_PANEL_ADMIN_ADD_MENU_LECTURE: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        if (s.id !== action.payload.sectionId)
                            return s;

                        return { ...s, lectures: [...s.lectures, action.payload.lecture] };
                    })
                }
            };
        }
        case LECTURE_PANEL_ADMIN_DELETE_MENU_LECTURE: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        return { ...s, lectures: s.lectures.filter(l => l.id !== action.payload.id) }
                    })
                }
            };
        }

        case LECTURE_PANEL_SET_CURRENT_LECTURE: {
            return { ...state, currentLectureId: parseInt(action.payload.id) };
        }
        case LECTURE_PANEL_TOGGLE_SECTION: {
            if (action.payload.open && !state.selectedSectionId.includes(action.payload.id)) {
                return { ...state, selectedSectionId: [...state.selectedSectionId, action.payload.id] };
            }

            if (!action.payload.open && state.selectedSectionId.includes(action.payload.id)) {
                return { ...state, selectedSectionId: state.selectedSectionId.filter(id => id !== action.payload.id) };
            }

            return state;
        }

        case LECTURE_PANEL_SET_LECTURE_AS_COMPLETED: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        return {
                            ...s, lectures: s.lectures.map(l => {
                                if (l.id === action.payload.id) {
                                    return { ...l, isDone: true };
                                }

                                return l;
                            })
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_SET_LECTURE_AS_UNLOCKED: {
            return {
                ...state, menu: {
                    ...state.menu, sections: state.menu.sections.map(s => {
                        return {
                            ...s, lectures: s.lectures.map(l => {
                                if (l.id === action.payload.id) {
                                    return { ...l, isAvailable: true };
                                }

                                return l;
                            })
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_SET_LECTURE_AS_FREE: {
            return { ...state, lecture: { ...state.lecture, free: action.payload.isFree } };
        }

        case LECTURE_PANEL_SET_CURRENT_VIDEO_ID: {
            return { ...state, currentVideoId: action.payload.id };
        }

        // ADMIN

        // Lecture : title
        case LECTURE_PANEL_ADMIN_SET_LECTURE_TITLE: {
            return { ...state, lecture: { ...state.lecture, title: action.payload.title } };
        }
        case LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_TITLE_STATUS: {
            return { ...state, onInputFocus: action.payload.isEditing, isEditingTitle: action.payload.isEditing };
        }
        case LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_TITLE: {
            return { ...state, editingLectureTitle: action.payload.title, isEditingLectureTitleValid: true };
        }

        // Lecture : description
        case LECTURE_PANEL_ADMIN_SET_EDITING_DESCRIPTION_STATUS: {
            return { ...state, onInputFocus: action.payload.isEditing, isEditingDescription: action.payload.isEditing };
        }
        case LECTURE_PANEL_ADMIN_SET_LECTURE_EDITING_DESCRIPTION: {
            return { ...state, editingLectureDescription: action.payload.description, isEditingLectureDescriptionValid: true };
        }
        case LECTURE_PANEL_ADMIN_SET_LECTURE_DESCRIPTION: {
            return { ...state, lecture: { ...state.lecture, description: action.payload.description } };
        }

        // section
        case LECTURE_PANEL_ADMIN_SET_SECTION_TITLE: {
            return {
                ...state, menu: {
                    ...state.menu, sections: [...state.menu.sections.map(s => {
                        if (s.id !== action.payload.id)
                            return s;

                        return { ...s, name: action.payload.title };
                    })]
                }
            };
        }
        case LECTURE_PANEL_ADMIN_SET_NEW_SECTION_UPDATE: {
            return { ...state, onInputFocus: action.payload.isEditing, updateNewSection: { isEditing: action.payload.isEditing, isValid: true } };
        }
        case LECTURE_PANEL_ADMIN_SET_NEW_SECTION_TITLE: {
            return { ...state, updateNewSection: { ...state.updateNewSection, title: action.payload.title, isValid: true } };
        }
        case LECTURE_PANEL_ADMIN_SET_EXISTING_SECTION_TITLE: {
            if (!state.updateExistingSection)
                return state;

            return {
                ...state,
                updateExistingSection: { ...state.updateExistingSection, title: action.payload.title },
                isSectionTitleValid: true
            };
        }
        case LECTURE_PANEL_ADMIN_SET_EXISTING_SECTION_UPDATE: {
            if (action.payload.id)
                return { ...state, onInputFocus: true, updateExistingSection: { id: action.payload.id, title: action.payload.title } };

            return { ...state, onInputFocus: false, updateExistingSection: null };
        }
        case LECTURE_PANEL_ADMIN_SET_NEW_SECTION_TITLE_LOADING: {
            return { ...state, updateNewSection: { ...state.updateNewSection, isLoading: action.payload.isLoading } };
        }

        // Resources
        case LECTURE_PANEL_ADMIN_ADD_EMBED_PAGE: {
            return { ...state, lecture: { ...state.lecture, embedPages: [...state.lecture.embedPages, action.payload.embedPage] } };
        }
        case LECTURE_PANEL_ADMIN_DELETE_EMBED_PAGE: {
            return { ...state, lecture: { ...state.lecture, embedPages: state.lecture.embedPages.filter(ep => ep.id !== action.payload.id) } };
        }

        case LECTURE_PANEL_ADMIN_ADD_DOCUMENTATION: {
            return { ...state, lecture: { ...state.lecture, documentations: [...state.lecture.documentations, action.payload.documentation] } };
        }
        case LECTURE_PANEL_ADMIN_DELETE_DOCUMENTATION: {
            return { ...state, lecture: { ...state.lecture, documentations: state.lecture.documentations.filter(d => d.id !== action.payload.id) } };
        }
        case LECTURE_PANEL_ADMIN_SET_DOCUMENTATIONS: {
            return { ...state, lecture: { ...state.lecture, documentations: action.payload.documentations } };
        }

        case LECTURE_PANEL_ADMIN_ADD_DOWNLOAD_FILE: {
            return { ...state, lecture: { ...state.lecture, downloads: [...state.lecture.downloads, action.payload.download] } };
        }
        case LECTURE_PANEL_ADMIN_DELETE_DOWNLOAD_FILE: {
            return { ...state, lecture: { ...state.lecture, downloads: state.lecture.downloads.filter(d => d.id !== action.payload.id) } };
        }
        case LECTURE_PANEL_ADMIN_SET_DOWNLOAD_FILES: {
            return { ...state, lecture: { ...state.lecture, downloads: action.payload.downloads } };
        }
        case LECTURE_PANEL_ADMIN_SET_DOWNLOAD_FILE_TITLE: {
            return {
                ...state, lecture: {
                    ...state.lecture, downloads: state.lecture.downloads.map(d => {
                        if (d.id !== action.payload.id)
                            return d;

                        return { ...d, title: action.payload.title };
                    })
                }
            }
        }

        case LECTURE_PANEL_ADMIN_ADD_ADDITIONAL: {
            return { ...state, lecture: { ...state.lecture, pictures: [...state.lecture.pictures, action.payload.picture] } };
        }
        case LECTURE_PANEL_ADMIN_DELETE_ADDITIONAL: {
            return { ...state, lecture: { ...state.lecture, pictures: state.lecture.pictures.filter(d => d.id !== action.payload.id) } };
        }
        case LECTURE_PANEL_ADMIN_SET_ADDITIONALS: {
            return { ...state, lecture: { ...state.lecture, pictures: action.payload.pictures } };
        }

        case LECTURE_PANEL_ADMIN_ADD_VIDEO: {
            return { ...state, lecture: { ...state.lecture, videos: [...state.lecture.videos, action.payload.video] } };
        }
        case LECTURE_PANEL_ADMIN_DELETE_VIDEO: {
            return { ...state, lecture: { ...state.lecture, videos: state.lecture.videos.filter(v => v.id !== action.payload.id) } };
        }

        // CHECK
        case LECTURE_PANEL_ADMIN_SECTION_TITLE_CHECK: {
            return { ...state, isSectionTitleValid: action.payload.isValid };
        }
        case LECTURE_PANEL_ADMIN_NEW_SECTION_TITLE_CHECK: {
            return { ...state, updateNewSection: { ...state.updateNewSection, isValid: action.payload.isValid } };
        }
        case LECTURE_PANEL_ADMIN_LECTURE_TITLE_CHECK: {
            return { ...state, isEditingLectureTitleValid: action.payload.isValid };
        }
        case LECTURE_PANEL_ADMIN_LECTURE_DESCRIPTION_CHECK: {
            return { ...state, isEditingLectureDescriptionValid: action.payload.isValid };
        }

        case LECTURE_PANEL_RESET: {
            return defaultState;
        }


        // SURVEY
        case LECTURE_PANEL_SURVEY_SET_STEP: {
            return { ...state, surveyStep: action.payload.step };
        }
        case LECTURE_PANEL_SURVEY_SET_LOADING: {
            return { ...state, isSurveyLoading: action.payload.isLoading };
        }
        case LECTURE_PANEL_SURVEY_SET_QUESTION_LOADING: {
            const { questionId, isLoading } = action.payload;
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === questionId) {
                            return { ...q, isLoading };
                        }

                        return q;
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_ANSWER_LOADING: {
            const { answerId, isLoading } = action.payload;
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        return {
                            ...q, surveyAnswer: q.surveyAnswer.map(a => {
                                if (a.id === answerId)
                                    return { ...a, isLoading };

                                return a;
                            })
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_SURVEY: {
            const { survey } = action.payload;

            if (survey === null)
                return { ...state, survey: null }
                
            return {
                ...state, survey: {
                    ...survey, surveyQuestion: survey.surveyQuestion.map(q => {
                        return { ...q, selectedAnswers: [] };
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_CURRENT_QUESTION_ID: {
            return { ...state, currentQuestionId: action.payload.id };
        }
        case LECTURE_PANEL_SURVEY_TOGGLE_SELECT_ANSWER: {
            const { questionId, answerId } = action.payload;
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === questionId) {
                            if (q.selectedAnswers?.includes(answerId))
                                return { ...q, selectedAnswers: q.selectedAnswers.filter(q => q !== answerId) };

                            return { ...q, selectedAnswers: [...q.selectedAnswers, answerId] };
                        }

                        return q;
                    })
                }
            }
        }
        case LECTURE_PANEL_SURVEY_SET_QUESTION_DONE: {
            const { questionId, done } = action.payload;
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === questionId)
                            return { ...q, done };

                        return q;
                    })
                }
            }
        }
        case LECTURE_PANEL_SURVEY_SET_RESULTS: {
            return { ...state, surveyResults: action.payload.results };
        }
        case LECTURE_PANEL_SURVEY_DELETE_QUESTION: {
            return {
                ...state, survey: {
                    ...state.survey,
                    surveyQuestion: state.survey.surveyQuestion.filter(q => q.id !== action.payload.questionId)
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_ANSWER_CORRECT: {
            const { answerId, correct } = action.payload;
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        return {
                            ...q, surveyAnswer: q.surveyAnswer.map(a => {
                                if (a.id === answerId)
                                    return { ...a, correct };

                                return a;
                            })
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_ADD_ANSWER: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === action.payload.questionId)
                            return { ...q, surveyAnswer: [...q.surveyAnswer, action.payload.answer] };

                        return q;
                    })
                }
            }
        }
        case LECTURE_PANEL_SURVEY_DELETE_ANSWER: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        return {
                            ...q, surveyAnswer: q.surveyAnswer.filter(a => a.id !== action.payload.answerId)
                        };
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_ANSWERS: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === action.payload.questionId)
                            return {
                                ...q, surveyAnswer: action.payload.answers
                            };

                        return q;
                    })
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_QUESTIONS: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: action.payload.questions
                }
            };
        }
        case LECTURE_PANEL_SURVEY_ADD_QUESTION: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: [...state.survey.surveyQuestion, action.payload.question]
                }
            };
        }
        case LECTURE_PANEL_SURVEY_SET_QUESTION_REQUIRED: {
            return {
                ...state, survey: {
                    ...state.survey, surveyQuestion: state.survey.surveyQuestion.map(q => {
                        if (q.id === action.payload.questionId)
                            return {
                                ...q, required: action.payload.required
                            };

                        return q;
                    })
                }
            };
        }

        case LECTURE_PANEL_SURVEY_SET_ADMIN_RESULTS_LOADING: {
            return { ...state, isAdminSurveyResultsLoading: action.payload.isLoading };
        }
        case LECTURE_PANEL_SURVEY_SET_ADMIN_RESULTS: {
            return { ...state, adminSurveyResults: action.payload.results };
        }
        case LECTURE_PANEL_SURVEY_SET_ADMIN_RESULT_LOADING: {
            return {
                ...state, adminSurveyResults: state.adminSurveyResults.map(r => {
                    if (r.id === action.payload.id)
                        return { ...r, isLoading: action.payload.isLoading };

                    return r;
                })
            }
        }
        case LECTURE_PANEL_SURVEY_DELETE_ADMIN_RESULT: {
            return {
                ...state, adminSurveyResults: state.adminSurveyResults.filter(r => r.id !== action.payload.id)
            }
        }

        default:
            return state;
    }
}